export const FETCH_MONTHLY_REPORT_REQUEST = "FETCH_MONTHLY_REPORT_REQUEST";
export const FETCH_MONTHLY_REPORT_SUCCESS = "FETCH_MONTHLY_REPORT_SUCCESS";
export const FETCH_MONTHLY_REPORT_FAILURE = "FETCH_MONTHLY_REPORT_FAILURE";
